let isInstalled = false;

const i18nPlugin = {
	install(Vue, options = {}) {
		if (isInstalled) return;
		isInstalled = true;

		const { translations = {}, lang = "en" } = options;

		if (!translations) {
			console.warn("i18nPlugin: No translations provided.");
			return;
		}

		if (!lang) {
			console.warn("i18nPlugin: No default language provided.");
			return;
		}

		const store = {
			currentLang: localStorage.getItem("currentLang") ?? lang,
			availableLangs: [
				...Object.values(translations).reduce((set, entry) => {
					Object.keys(entry).forEach(set.add, set);
					return set;
				}, new Set()),
			],
		};

		localStorage.setItem("currentLang", store.currentLang);

		const langChangeListeners = new Set();

		function $t(key, variables) {
			const translationEntry = translations[key];
			const translationLanguageItem = translationEntry?.[store.currentLang];

			if (!translationLanguageItem) {
				console.warn(
					`i18nPlugin: Translation for key "${key}" in language "${store.currentLang}" not found.`
				);
			}

			const translationStr = translationLanguageItem || key;

			if (variables) {
				return translationStr.replace(/\${(\w+)\}/g, (match, capture) => {
					return variables[capture] ?? match;
				});
			}

			return translationStr;
		}

		$t.setLang = function(lang) {
			if (!store.availableLangs.includes(lang)) {
				console.warn(`i18nPlugin: Language "${lang}" is not available.`);
				return;
			}

			store.currentLang = lang;
			$t.currentLang = lang;
			localStorage.setItem("currentLang", lang);
			langChangeListeners.forEach((callback) => callback(lang));
		};

		$t.onLangChange = function(callback) {
			if (typeof callback === "function") {
				langChangeListeners.add(callback);

				return function() {
					langChangeListeners.delete(callback);
				};
			}

			console.warn(
				`i18nPlugin: onLangChange callbacks must be a function. Received: ${typeof callback}`
			);

			return () => {};
		};

		Object.assign($t, store);

		Vue.mixin({
			data() {
				return {
					PRIVATE_t: store,
				};
			},
			computed: {
				$t() {
					// for the sake of reactivity
					this.PRIVATE_t.currentLang;
					return $t;
				},
			},
		});

		Vue.$t = $t;
	},
};

export default i18nPlugin;
